import { gql } from '@lcs/shared/api';

export const getExtensionMailboxQuery = gql`
   query GetMailboxRegister($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      mailboxesConnection(first: $first, filters: $filters, after: $after, orderingOptions: $orderingOptions) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            mailboxId
            extension {
               extensionId
               name
               number
               extensionType {
                  name
               }
            }
            unreadMailboxMessageCount
            password
            unavailablePromptId2
            namePromptId
            busyPromptId
            emailAddress
            mailboxMessagesConnection {
               items {
                  isArchived
                  mailboxFolderId
               }
            }
         }
      }
   }
`;
